var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-list',{attrs:{"show-tag-columns":"","show-tag-filter":"","columns":_vm.columns,"group-actions":_vm.groupActions,"list":_vm.list,"single-actions":_vm.singleActions,"export-data-options":_vm.exportDataOptions}})}
var staticRenderFns = []

export { render, staticRenderFns }